module.exports = __webpack_public_path__ + "img/未标题-1.f289452c.png";